
import { mapState, mapGetters } from 'vuex';
import AppAiIcon from '@/components/core/AppAiIcon';
import AppAjaxContent from '@/components/core/AppAjaxContent';
import AiIconType from '@/enums/AiIconType';

export default {
  i18nComponentKey: 'WidgetAddOnReviewsSummary.components.ReviewsSummary',
  name: 'ReviewsSummary',
  components: { AppAiIcon, AppAjaxContent },
  data() {
    return {
      isCollapsed: true,
      reviewsSummary: {},
      isLoading: true
    };
  },
  computed: {
    ...mapState(['api', 'productCode']),
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', ['isMobileViewport']),
    ...mapState('reviewSettings', ['reviewSettings']),
    isGradientAiIconType() {
      return this.reviewSettings.ai_icon_type === AiIconType.GRADIENT;
    },
    hasReviewsSummary() {
      const reviewsSummary = this.reviewsSummary;
      return (
        !!reviewsSummary?.summary_one_line && !!reviewsSummary?.summary_positive
      );
    },
    showSummaryNegative() {
      return (
        !!this.reviewsSummary?.summary_negative &&
        this.widget.use_reviews_summary_negative
      );
    },
    summaryNegativeText() {
      const NEGATIVE_REVIEW_TAG_THRESHOLD = 5;
      if (
        this.reviewsSummary.negative_review_tag_percentage <
        NEGATIVE_REVIEW_TAG_THRESHOLD
      ) {
        return this.$t('mostly_positive_reviews');
      } else {
        return this.reviewsSummary.summary_negative;
      }
    },
    truncatedSummaryNegativeText() {
      if (this.showSummaryNegative) {
        return this.$t('truncated_summary_negative');
      } else {
        return this.$t('ellipsis');
      }
    },
    sentimentAnalysisText() {
      const percentage = Math.round(
        this.reviewsSummary.positive_review_percentage
      );

      if (percentage >= 90) {
        return this.$t('sentiment_analysis.gte_90', [percentage]);
      } else if (percentage >= 80) {
        return this.$t('sentiment_analysis.gte_80', [percentage]);
      } else if (percentage >= 70) {
        return this.$t('sentiment_analysis.gte_70', [percentage]);
      } else if (percentage >= 60) {
        return this.$t('sentiment_analysis.gte_60', [percentage]);
      } else {
        return this.$t('sentiment_analysis.lt_60', [percentage]);
      }
    },
    showCollapsed() {
      return this.isMobileViewport && this.isCollapsed;
    },
    tooltipText() {
      return this.$t(
        this.hasReviewsSummary
          ? 'tooltip_summary_completed'
          : 'tooltip_summary_unavailable'
      );
    }
  },
  mounted() {
    this.api
      .fetchReviewsSummary(this.productCode)
      .then(({ data }) => {
        this.reviewsSummary = data.reviews_summary;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
};
